import { Link } from 'react-router-dom';
import Logo from '@/components/base/Logo';

const Footer = () => {
  const serviceLinks = [
    { name: 'Web Development', slug: 'web-development' },
    { name: 'Mobile App Development', slug: 'mobile-app-development' },
    { name: 'Digital Marketing', slug: 'digital-marketing' },
    { name: 'UI/UX Design', slug: 'ui-ux-design' },
    { name: 'Cloud Solutions', slug: 'cloud-solutions' },
    { name: 'IT Consulting', slug: 'it-consulting' },
  ];

  return (
    <footer className="relative w-full bg-background-100 border-t border-background-200 pt-20 pb-8">
      <div className="section-padding">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 mb-16">
          <div className="lg:col-span-4">
            <Logo variant="light" size="lg" />
            <p className="mt-5 text-sm text-foreground-700 leading-relaxed max-w-md">
              Transforming ideas into powerful digital solutions. We build next-generation software that drives innovation and growth for businesses worldwide.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href="https://linkedin.com/company/bitninjatech" rel="nofollow noopener noreferrer" target="_blank" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-colors cursor-pointer" aria-label="BitNinja Technologies on LinkedIn">
                <i className="ri-linkedin-fill text-base"></i>
              </a>
              <a href="https://instagram.com/bitninjatech" rel="nofollow noopener noreferrer" target="_blank" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-colors cursor-pointer" aria-label="BitNinja Technologies on Instagram">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="https://youtube.com/@bitninjatech" rel="nofollow noopener noreferrer" target="_blank" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-colors cursor-pointer" aria-label="BitNinja Technologies on YouTube">
                <i className="ri-youtube-fill text-base"></i>
              </a>
              <a href="https://github.com/bitninjatech" rel="nofollow noopener noreferrer" target="_blank" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-colors cursor-pointer" aria-label="BitNinja Technologies on GitHub">
                <i className="ri-github-fill text-base"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-500 mb-4">Services</div>
            <ul className="space-y-3">
              {serviceLinks.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-sm text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-500 mb-4">Company</div>
            <ul className="space-y-3">
              <li><button onClick={() => window.location.href = '/#about'} className="text-sm text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer text-left">About Us</button></li>
              <li><button onClick={() => window.location.href = '/#portfolio'} className="text-sm text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer text-left">Portfolio</button></li>
              <li><button onClick={() => window.location.href = '/#blog'} className="text-sm text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer text-left">Blog</button></li>
              <li><button onClick={() => window.location.href = '/#contact'} className="text-sm text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer text-left">Contact</button></li>
              <li><button onClick={() => window.location.href = '/#contact'} className="text-sm text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer text-left">Careers</button></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-500 mb-4">Our Location</div>
            <p className="text-sm text-foreground-700 mb-4">212, Meridian Business Center, Lajamni Chowk, Surat, Gujarat 394101</p>
            <div className="w-full h-44 rounded-2xl overflow-hidden border border-background-200">
              <iframe
                title="BitNinja Technologies Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.7!2d72.8777!3d21.2358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f0e0b000001%3A0x1!2sMeridian+Business+Center%2C+Lajamni+Chowk%2C+Mota+Varachha%2C+Surat%2C+Gujarat+394101!5e0!3m2!1sen!2sin!4v1712000000000!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden border border-background-200 bg-background-50 mb-10">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="flex items-center gap-4 px-6 py-6 border-b md:border-b-0 md:border-r border-background-200 last:border-0">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 font-mono text-xs">IN</span>
              <Link to="/surat" className="hover:text-primary-500 transition-colors cursor-pointer">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-foreground-500">Headquarters</div>
                  <div className="font-display text-base font-bold text-foreground-900">Surat, IN</div>
                </div>
              </Link>
            </div>
            <div className="flex items-center gap-4 px-6 py-6 border-b md:border-b-0 md:border-r border-background-200 last:border-0">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 font-mono text-xs">US</span>
              <Link to="/san-francisco" className="hover:text-primary-500 transition-colors cursor-pointer">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-foreground-500">Office</div>
                  <div className="font-display text-base font-bold text-foreground-900">California, US</div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-6 border-t border-background-200 font-mono text-[10px] uppercase tracking-widest text-foreground-500">
          <div>&copy; 2026 BitNinja Technologies. All rights reserved.</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <a className="hover:text-foreground-900 cursor-pointer" href="/#contact">Privacy</a>
            <a className="hover:text-foreground-900 cursor-pointer" href="/#contact">Terms</a>
            <a className="hover:text-foreground-900 cursor-pointer" href="/#contact">Cookies</a>
            <a className="hover:text-foreground-900 cursor-pointer" href="/#contact">Imprint</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;